import { render, staticRenderFns } from "./WitcherHeader.vue?vue&type=template&id=c4f1e146&scoped=true&"
import script from "./WitcherHeader.vue?vue&type=script&lang=js&"
export * from "./WitcherHeader.vue?vue&type=script&lang=js&"
import style0 from "./WitcherHeader.vue?vue&type=style&index=0&id=c4f1e146&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4f1e146",
  null
  
)

export default component.exports